import { appConfig } from "../config/appConfig";
import { UPLOADTYPE } from "../models/enums/globalEnums";
import { fetchSasUrl } from "./IndiaService";
import { getStorageItemLocal } from "./storageServices";

const EXTRA_SYNC_BLOB_PATH = "Categories/extra_categories_sync.json";
export const EXTRA_SYNC_PUBLIC_URL =
  "https://stcorpitcmapprodcms.blob.core.windows.net/file-uploads/Categories/extra_categories_sync.json";

const SEEDED_EXTRA_INDIA_ENTRIES: Record<string, any> = {
  "11": {
    id: 101,
    category: 11,
    categoryName: "Extra1",
    subCategory: "null",
    description: "points 1",
    description2: "points 2",
    description3: "points 3",
    isActive: true,
    lastUpdated: "2026-10-16T08:37:37.0000000",
    imageUrls: "",
    videoUrls: "",
    thumbnail: "",
    pdfUrls: null,
    pdfIsActive: false,
    pdfName: "null",
    pdfUrls2: null,
    pdfIsActive2: false,
    pdfName2: "null",
    pdfUrls3: null,
    pdfIsActive3: false,
    pdfName3: "null",
    grid1:
      "https://stcorpitcmapprodcms.blob.core.windows.net/file-uploads/India/images/639277366576430000.png?grid=1",
    gridThumbnail1:
      "https://stcorpitcmapprodcms.blob.core.windows.net/file-uploads/India/images/639277366546850000.png",
    gridType1: "IMAGES",
    gridIconName1: "Test",
    grid2: null,
    gridThumbnail2: null,
    gridType2: "null",
    gridIconName2: "null",
    grid3: null,
    gridThumbnail3: null,
    gridType3: "null",
    gridIconName3: "null",
    grid4: null,
    gridThumbnail4: null,
    gridType4: "null",
    gridIconName4: "null",
    grid5: null,
    gridThumbnail5: null,
    gridType5: "null",
    gridIconName5: "null",
    grid6: null,
    gridThumbnail6: null,
    gridType6: "null",
    gridIconName6: "null",
    grid7: null,
    gridThumbnail7: null,
    gridType7: "null",
    gridIconName7: "null",
    grid8: null,
    gridThumbnail8: null,
    gridType8: "null",
    gridIconName8: "null",
    grid9: null,
    gridThumbnail9: null,
    gridType9: "null",
    gridIconName9: "null",
    status: "Published",
    statusCode: "3",
  },
  "12": {
    id: 102,
    category: 12,
    categoryName: "Extra2",
    subCategory: "null",
    description: "points 1",
    description2: "points 2",
    description3: "points 3",
    isActive: true,
    lastUpdated: "2026-10-16T08:38:57.7003018",
    imageUrls: "",
    videoUrls: "",
    thumbnail: "",
    pdfUrls: null,
    pdfIsActive: false,
    pdfName: "null",
    pdfUrls2: null,
    pdfIsActive2: false,
    pdfName2: "null",
    pdfUrls3: null,
    pdfIsActive3: false,
    pdfName3: "null",
    grid1:
      "https://stcorpitcmapprodcms.blob.core.windows.net/file-uploads/India/images/639277367116920000.png?grid=1",
    gridThumbnail1:
      "https://stcorpitcmapprodcms.blob.core.windows.net/file-uploads/India/images/639277367090760000.png",
    gridType1: "IMAGES",
    gridIconName1: "Test2",
    grid2: null,
    gridThumbnail2: null,
    gridType2: "null",
    gridIconName2: "null",
    grid3: null,
    gridThumbnail3: null,
    gridType3: "null",
    gridIconName3: "null",
    grid4: null,
    gridThumbnail4: null,
    gridType4: "null",
    gridIconName4: "null",
    grid5: null,
    gridThumbnail5: null,
    gridType5: "null",
    gridIconName5: "null",
    grid6: null,
    gridThumbnail6: null,
    gridType6: "null",
    gridIconName6: "null",
    grid7: null,
    gridThumbnail7: null,
    gridType7: "null",
    gridIconName7: "null",
    grid8: null,
    gridThumbnail8: null,
    gridType8: "null",
    gridIconName8: "null",
    grid9: null,
    gridThumbnail9: null,
    gridType9: "null",
    gridIconName9: "null",
    status: "Published",
    statusCode: "3",
  },
};

const ensureStringArray = (val: any): string[] => {
  if (!val) return [];
  if (Array.isArray(val)) {
    return val
      .map((v) => String(v || "").trim())
      .filter((v) => v && v !== "null");
  }
  if (typeof val === "string") {
    return val
      .split(",")
      .map((v) => v.trim())
      .filter((v) => v && v !== "null");
  }
  return [];
};

const firstString = (val: any): string => {
  const arr = ensureStringArray(val);
  return arr.length > 0 ? arr[0] : "";
};

const withGridQuery = (url: string, gridIdx: number): string => {
  if (!url) return "";
  const clean = url.split("?")[0];
  return `${clean}?grid=${gridIdx}`;
};

export const parseGridFields = (entry: any) => {
  const OpensCategoryShortcut: { OpensCategory: string; ThumbnailUrl: string }[] = [];
  const VideoLinks: { VideoName: string; VideoUrl: string; ThumbnailUrl: string }[] = [];
  const GalleryImages: { GalleryName: string; Thumbnail: string; Images: string[] }[] = [];
  const PDFGridItems: { PDFLink: string; ThumbnailUrl: string }[] = [];

  if (!entry) {
    return { OpensCategoryShortcut, VideoLinks, GalleryImages, PDFGridItems };
  }

  for (let g = 1; g <= 9; g++) {
    const rawType = String(entry[`gridType${g}`] || "").trim().toUpperCase();
    const gridUrls = ensureStringArray(entry[`grid${g}`]);
    const thumbUrl = firstString(entry[`gridThumbnail${g}`]);
    const iconName =
      entry[`gridIconName${g}`] && entry[`gridIconName${g}`] !== "null"
        ? String(entry[`gridIconName${g}`])
        : "";

    if (!rawType || rawType === "NULL" || gridUrls.length === 0) continue;

    if (rawType === UPLOADTYPE.IMAGES || rawType === "IMAGE") {
      GalleryImages.push({
        GalleryName: iconName,
        Thumbnail: thumbUrl,
        Images: gridUrls.map((u) => withGridQuery(u, g)),
      });
    } else if (rawType === UPLOADTYPE.VIDEO) {
      VideoLinks.push({
        VideoName: iconName,
        VideoUrl: withGridQuery(gridUrls[0], g),
        ThumbnailUrl: thumbUrl,
      });
    } else if (rawType === UPLOADTYPE.PDF) {
      PDFGridItems.push({
        PDFLink: withGridQuery(gridUrls[0], g),
        ThumbnailUrl: thumbUrl,
      });
    } else if (rawType === UPLOADTYPE.LINK || rawType === "CATEGORY") {
      OpensCategoryShortcut.push({
        OpensCategory: gridUrls[0].split("?")[0],
        ThumbnailUrl: thumbUrl,
      });
    }
  }

  return { OpensCategoryShortcut, VideoLinks, GalleryImages, PDFGridItems };
};

const uploadFixedJsonBlob = async (
  jsonContent: string,
  containerName: string,
  sasUrl: string,
  blobPath: string
): Promise<string> => {
  const urlParts = sasUrl.split("?");
  let baseUrl = urlParts[0];
  if (
    !baseUrl.endsWith(`/${containerName}`) &&
    !baseUrl.includes(`/${containerName}/`)
  ) {
    baseUrl = baseUrl.endsWith("/")
      ? `${baseUrl}${containerName}`
      : `${baseUrl}/${containerName}`;
  }
  const query = urlParts[1] ? `?${urlParts[1]}` : "";
  const uploadUrl = `${baseUrl}/${blobPath}${query}`;

  const performPut = (targetUrl: string, blobOriginHeader?: string) =>
    new Promise<string>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", targetUrl, true);
      xhr.setRequestHeader("x-ms-blob-type", "BlockBlob");
      xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
      xhr.setRequestHeader(
        "x-ms-blob-cache-control",
        "no-cache, no-store, must-revalidate"
      );
      if (blobOriginHeader) {
        xhr.setRequestHeader("x-blob-target-origin", blobOriginHeader);
      }
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(`${baseUrl}/${blobPath}`);
        } else {
          const err: any = new Error(`Status ${xhr.status}`);
          err.status = xhr.status;
          reject(err);
        }
      };
      xhr.onerror = () =>
        reject(new Error("Network error uploading extra categories JSON"));
      xhr.send(jsonContent);
    });

  if (
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1")
  ) {
    const parsed = new URL(uploadUrl);
    const proxyPath = `/__blob_proxy${parsed.pathname}${parsed.search}`;
    try {
      return await performPut(proxyPath, parsed.origin);
    } catch (err: any) {
      if (err?.status === 404) {
        return await performPut(
          `http://localhost:3005${proxyPath}`,
          parsed.origin
        );
      }
      throw err;
    }
  }

  return performPut(uploadUrl);
};

export const fetchExistingExtraSyncData = async (): Promise<any | null> => {
  try {
    const res = await fetch(`${EXTRA_SYNC_PUBLIC_URL}?t=${Date.now()}`, {
      cache: "no-store",
    });
    if (res.ok) {
      return await res.json();
    }
  } catch (e) {
    // Ignore if blob doesn't exist yet
  }
  return null;
};

export const saveExtraIndiaEntryLocal = async (entry: any) => {
  try {
    const existing = (await fetchExistingExtraSyncData()) || {};
    const localIndiaCache = JSON.parse(
      localStorage.getItem("extraIndiaEntriesCache") || "{}"
    );
    const extraIndiaEntries: Record<string, any> = {
      ...SEEDED_EXTRA_INDIA_ENTRIES,
      ...(existing.ExtraIndiaEntries || {}),
      ...localIndiaCache,
    };
    const catKey = String(entry.category || entry.categoryName || "").trim();
    if (catKey) {
      extraIndiaEntries[catKey] = {
        ...extraIndiaEntries[catKey],
        ...entry,
        lastUpdated: new Date().toISOString(),
      };
      localStorage.setItem(
        "extraIndiaEntriesCache",
        JSON.stringify(extraIndiaEntries)
      );
    }
  } catch (e) {
    console.warn("Failed to cache extra India entry:", e);
  }
};

export const saveExtraStateEntryLocal = async (entry: any) => {
  try {
    const existing = (await fetchExistingExtraSyncData()) || {};
    const localStateCache = JSON.parse(
      localStorage.getItem("extraStateEntriesCache") || "{}"
    );
    const extraStateEntries: Record<string, any> = {
      ...(existing.ExtraStateEntries || {}),
      ...localStateCache,
    };
    const stateKey = String(entry.stateName || entry.state || "").trim();
    const catKey = String(entry.category || entry.categoryName || "").trim();
    if (stateKey && catKey) {
      extraStateEntries[`${stateKey}__${catKey}`] = {
        ...extraStateEntries[`${stateKey}__${catKey}`],
        ...entry,
        lastUpdated: new Date().toISOString(),
      };
      localStorage.setItem(
        "extraStateEntriesCache",
        JSON.stringify(extraStateEntries)
      );
    }
  } catch (e) {
    console.warn("Failed to cache extra State entry:", e);
  }
};

let syncInProgress = false;

export const syncExtraCategoriesToBlob = async (): Promise<any> => {
  if (syncInProgress) return null;
  const tokenString = getStorageItemLocal("token");
  const token = tokenString ? JSON.parse(tokenString) : null;
  if (!token) return null;

  syncInProgress = true;
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const [catRes, indiaRes, indiaImgRes, stateRes, statesListRes, existingBlob] =
      await Promise.all([
        fetch(appConfig.serviceUrls.saveCategory, { method: "GET", headers }),
        fetch(appConfig.serviceUrls.saveIndiaEntries, {
          method: "GET",
          headers,
        }),
        fetch(appConfig.serviceUrls.saveIndiaImageEntries, {
          method: "GET",
          headers,
        }),
        fetch(appConfig.serviceUrls.saveStateEntries, {
          method: "GET",
          headers,
        }),
        fetch(appConfig.serviceUrls.getActiveState, {
          method: "GET",
          headers,
        }),
        fetchExistingExtraSyncData(),
      ]);

    if (!catRes.ok) return null;

    const allCats: any[] = (await catRes.json()) || [];
    const indiaEntries: any[] = indiaRes.ok ? (await indiaRes.json()) || [] : [];
    const indiaImages: any[] = indiaImgRes.ok
      ? (await indiaImgRes.json()) || []
      : [];
    const stateEntries: any[] = stateRes.ok ? (await stateRes.json()) || [] : [];
    const statesList: any[] = statesListRes.ok
      ? (await statesListRes.json()) || []
      : [];

    const stateIdToNameMap = new Map<string, string>();
    statesList.forEach((st: any) => {
      if (st && st.id != null && st.name) {
        stateIdToNameMap.set(String(st.id).trim(), String(st.name).trim());
      }
    });
    stateEntries.forEach((se: any) => {
      if (se && se.state != null && se.stateName) {
        stateIdToNameMap.set(String(se.state).trim(), String(se.stateName).trim());
      }
    });

    const resolveStateName = (se: any): string => {
      if (!se) return "";
      const rawStateName = String(se.stateName || "").trim();
      if (rawStateName && !/^\d+$/.test(rawStateName)) {
        return rawStateName;
      }
      const rawState = String(se.state || rawStateName || "").trim();
      if (stateIdToNameMap.has(rawState)) {
        return stateIdToNameMap.get(rawState) || "";
      }
      if (rawState && !/^\d+$/.test(rawState)) {
        return rawState;
      }
      return "";
    };

    const localIndiaCache = JSON.parse(
      localStorage.getItem("extraIndiaEntriesCache") || "{}"
    );
    const extraIndiaEntries: Record<string, any> = {
      ...SEEDED_EXTRA_INDIA_ENTRIES,
      ...(existingBlob?.ExtraIndiaEntries || {}),
      ...localIndiaCache,
    };

    const localStateCache = JSON.parse(
      localStorage.getItem("extraStateEntriesCache") || "{}"
    );
    const rawExtraStateEntries: Record<string, any> = {
      ...(existingBlob?.ExtraStateEntries || {}),
      ...localStateCache,
    };
    const extraStateEntries: Record<string, any> = {};
    Object.values(rawExtraStateEntries).forEach((se: any) => {
      if (!se) return;
      const resolvedState = resolveStateName(se);
      const catKey = String(se.category || se.categoryName || "").trim();
      if (resolvedState && catKey) {
        se.stateName = resolvedState;
        extraStateEntries[`${resolvedState}__${catKey}`] = se;
      }
    });

    // Sort categories by numeric ID ascending to identify categories beyond the first 10
    const catsById = [...allCats].sort((a, b) => (a.id ?? 0) - (b.id ?? 0));
    const extraCats = catsById.slice(10); // index 10 -> category002, index 11 -> category003

    const rootCategories: Record<string, any> = {};
    const stateCategories: Record<string, Record<string, any>> = {};

    extraCats.forEach((cat, idx) => {
      const categoryID = `category${String(idx + 2).padStart(3, "0")}`; // category002, category003
      const catName = String(cat.name || cat.categoryName || "").trim();
      const catIdNum = Number(cat.id);

      const matchesCategory = (entry: any) => {
        if (!entry) return false;
        const entryCatName = String(entry.categoryName || "")
          .trim()
          .toLowerCase();
        const entryCatId = Number(entry.category ?? entry.categoryId);
        if (catName && entryCatName === catName.toLowerCase()) return true;
        if (!isNaN(catIdNum) && !isNaN(entryCatId) && entryCatId === catIdNum)
          return true;
        return false;
      };

      const indiaEntry =
        indiaEntries.find((e) => matchesCategory(e)) ||
        extraIndiaEntries[String(catIdNum)] ||
        extraIndiaEntries[catName] ||
        null;

      if (indiaEntry) {
        indiaEntry.categoryName = catName;
        extraIndiaEntries[String(catIdNum)] = indiaEntry;
      }

      const existingRootCat = existingBlob?.Categories?.[categoryID];

      const catIndiaImages = indiaImages.filter(
        (img) => matchesCategory(img) && img.isActive !== false
      );

      let {
        OpensCategoryShortcut,
        VideoLinks,
        GalleryImages,
        PDFGridItems,
      } = parseGridFields(indiaEntry);

      if (
        GalleryImages.length === 0 &&
        VideoLinks.length === 0 &&
        PDFGridItems.length === 0 &&
        OpensCategoryShortcut.length === 0 &&
        existingRootCat
      ) {
        OpensCategoryShortcut = existingRootCat.OpensCategoryShortcut || [];
        VideoLinks = existingRootCat.VideoLinks || [];
        GalleryImages = existingRootCat.GalleryImages || [];
        PDFGridItems = existingRootCat.PDFGridItems || [];
      }

      const ImageDocuments =
        catIndiaImages.length > 0
          ? catIndiaImages.map((img) => ({
              GalleryName: String(img.imageName || ""),
              Thumbnail: "",
              Images: ensureStringArray(img.imageUrls),
            }))
          : existingRootCat?.ImageDocuments || [];

      const latestTimestamp =
        indiaEntry?.lastUpdated &&
        (!cat.lastUpdated || indiaEntry.lastUpdated > cat.lastUpdated)
          ? indiaEntry.lastUpdated
          : cat.lastUpdated || new Date().toISOString();

      rootCategories[categoryID] = {
        CategoryID: categoryID,
        Name: catName,
        Priority: String(cat.priority ?? idx + 11),
        Show: Boolean(cat.isActive),
        IconUrl: firstString(cat.icon),
        PinIcon: firstString(cat.pinIcon),
        LastUpdated: latestTimestamp,
        Description1:
          indiaEntry?.description || existingRootCat?.Description1 || "null",
        Description2:
          indiaEntry?.description2 || existingRootCat?.Description2 || "null",
        Description3:
          indiaEntry?.description3 || existingRootCat?.Description3 || "null",
        OpensCategoryShortcut,
        VideoLinks,
        GalleryImages,
        PDFGridItems,
        ImageDocuments,
      };

      // State-level entries for this extra category (prefer official API entries over local cache)
      const matchedStatesMap = new Map<string, any>();
      Object.values(extraStateEntries).forEach((se: any) => {
        if (matchesCategory(se)) {
          const stName = resolveStateName(se);
          if (stName) matchedStatesMap.set(stName, se);
        }
      });
      stateEntries
        .filter((se) => matchesCategory(se) && se.isActive !== false)
        .forEach((se) => {
          const stName = resolveStateName(se);
          if (stName) matchedStatesMap.set(stName, se);
        });

      matchedStatesMap.forEach((se, stateName) => {
        if (!stateName || /^\d+$/.test(stateName)) return;
        if (!stateCategories[stateName]) {
          stateCategories[stateName] = {};
        }
        const stateGrids = parseGridFields(se);
        const isActiveVal =
          se.isActive !== false && String(se.isActive).toLowerCase() !== "false";
        stateCategories[stateName][categoryID] = {
          CategoryID: categoryID,
          Name: catName,
          Priority: null,
          Show: Boolean(isActiveVal && cat.isActive),
          IconUrl: firstString(cat.icon),
          PinIcon: firstString(cat.pinIcon),
          LastUpdated: se.lastUpdated || latestTimestamp,
          Description1: se.description || "null",
          Description2: se.description2 || "null",
          Description3: se.description3 || "null",
          OpensCategoryShortcut: stateGrids.OpensCategoryShortcut,
          VideoLinks: stateGrids.VideoLinks,
          GalleryImages: stateGrids.GalleryImages,
          PDFGridItems: stateGrids.PDFGridItems,
        };
      });
    });

    localStorage.setItem(
      "extraStateEntriesCache",
      JSON.stringify(extraStateEntries)
    );
    localStorage.setItem(
      "extraIndiaEntriesCache",
      JSON.stringify(extraIndiaEntries)
    );

    const payload = {
      LastUpdated: new Date().toISOString(),
      Categories: rootCategories,
      StateCategories: stateCategories,
      ExtraIndiaEntries: extraIndiaEntries,
      ExtraStateEntries: extraStateEntries,
    };

    const jsonString = JSON.stringify(payload, null, 2);

    if (
      typeof window !== "undefined" &&
      (window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1")
    ) {
      fetch("http://localhost:3005/__debug_cats", {
        method: "POST",
        body: jsonString,
      }).catch(() => {});
    }

    const sasUrl = await fetchSasUrl("file-uploads");
    const uploadedUrl = await uploadFixedJsonBlob(
      jsonString,
      "file-uploads",
      sasUrl,
      EXTRA_SYNC_BLOB_PATH
    );
    console.log("[EXTRA CATEGORIES SYNC] Uploaded:", uploadedUrl);
    return payload;
  } catch (err) {
    console.warn("[EXTRA CATEGORIES SYNC] Non-fatal error:", err);
    return null;
  } finally {
    syncInProgress = false;
  }
};
